/** Introduction to the recall check on result and model pages. */
export const RECALL_LEAD =
  'Mit Rückrufen beheben Hersteller Mängel, etwa an Bremsen, Airbags oder der Abgasreinigung. Die Reparatur ist in der Regel kostenlos – behoben ist der Mangel aber erst, wenn eine Vertragswerkstatt sie durchgeführt hat.';
